import React, { forwardRef } from 'react';
import BootstrapButton from "../BootstrapButton";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    className?: string;
}

const PrimaryButtonLarge = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
    const { className, children, ...rest } = props;

    return (
        <BootstrapButton
            ref={ref}
            variant={'primary'}
            size={'lg'}
            className={className}
            {...rest}
        >
            {children}
        </BootstrapButton>
    );
});

export default PrimaryButtonLarge;
